import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Field } from 'formik';
import { useAemConfig } from '@as-react/common-components';
import FormValidationUtil from '../../../../util/FormValidationUtil';
import DateField from '../date-field/DateField';
import { Label } from '../label/Label';
import { FormMessage } from '../message/FormMessage';
import { SelectField } from '../select-field/SelectField';
import { FormFieldType } from '../../../../constants/FormConstants';
const FormField = props => {
    const { isShopLanding } = useAemConfig();
    const buildClassName = (defaultClass, errorClass, error) => defaultClass + ' ' + FormValidationUtil.processFieldError(errorClass, error);
    const getName = () => props.name || props.formFieldType.name;
    const renderLabel = (translation, required, className) => (_jsx(Label, { className: className, translation: translation, htmlFor: getName(), required: required || false }));
    const onKeyUp = (e) => {
        if (isShopLanding) {
            const event = document.createEvent('Event');
            event.initEvent('change', true, true);
            e.currentTarget.dispatchEvent(event);
        }
    };
    const renderInternalLabel = () => {
        const { required, formFieldType } = props;
        let finalTranslation = props.translation;
        if (!finalTranslation) {
            finalTranslation = formFieldType.translation;
        }
        return renderLabel(finalTranslation, required);
    };
    const renderField = (field, type, className) => (_jsx(Field, Object.assign({ className: className, type: type, id: field.name, placeholder: props.placeholder, onKeyUp: onKeyUp }, field)));
    const renderInternalField = (field, form, hasActiveError) => {
        const { formFieldType, data } = props;
        switch (formFieldType.type) {
            case FormFieldType.SELECT: {
                const className = buildClassName('a-select', 'a-select--error', hasActiveError);
                return _jsx(SelectField, { data: data, field: field, className: className });
            }
            case FormFieldType.DATE: {
                const className = buildClassName('a-input', 'a-input--error', hasActiveError);
                return _jsx(DateField, { data: data, field: field, className: className });
            }
            default: {
                const className = buildClassName('a-input', 'a-input--error', hasActiveError);
                return renderField(field, formFieldType.type, className);
            }
        }
    };
    const renderErrorSection = (name, errors) => (_jsx(FormMessage, { message: errors[name] }));
    const renderFieldSection = (field, form) => {
        const { touched, errors } = form;
        const getDynamicObject = (variableKey, baseVariable) => {
            return variableKey.split('.').reduce(function (cur, key) {
                if (!!cur && !!cur[key]) {
                    return cur[key];
                }
                return undefined;
            }, baseVariable);
        };
        const hasActiveError = !!(getDynamicObject(field.name, touched) && errors[field.name]);
        return (_jsxs(_Fragment, { children: [renderInternalField(field, form, hasActiveError), hasActiveError && renderErrorSection(field.name, errors)] }));
    };
    const renderControl = () => (_jsxs(_Fragment, { children: [renderInternalLabel(), _jsx(Field, { name: getName(), children: ({ field, form }) => renderFieldSection(field, form) })] }));
    return _jsx("div", { className: "m-form-control", children: renderControl() });
};
export default FormField;
